import { addEthnio, removeEthnio } from '@shared/utilities/ethnio/ethnio';
import { useEffect } from 'react';

interface Props {
    code: number;
}

export default function Ethnio({ code }: Props) {
    useEffect(() => {
        addEthnio(code);

        return () => {
            removeEthnio(code);
        };
    }, [code]);

    return <></>;
}
